import styled from '@emotion/styled';
import {
  COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
  BREAKPOINTS,
} from '@ordermentum/ui-constants';

const Container = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    flex-direction: column;
    width: 100%;
  }
`;

const ContentContainer = styled('div')`
  display: flex;
  width: 80%;
  max-width: 800px;
  flex-direction: column;
  text-align: center;
  padding: 2.5rem 4rem;
  & > div:not(:first-child) {
    padding-top: 2rem;
  }
  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    width: 100%;
    padding: 1rem;
  }
`;

const Header = styled('div')`
  font-size: ${FONT_SIZE['2XL']};
  font-weight: ${FONT_WEIGHT.NORMAL};
  text-align: center;
  color: ${COLOR.ORANGE};
`;

const Text = styled('p')`
  font-size: ${FONT_SIZE.BASE};
  font-weight: ${FONT_WEIGHT.LIGHT};
`;

const CTA = styled('a')`
  color: ${COLOR.ORANGE};
`;

const TextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  & > div:not(:first-child) {
    margin-top: 1rem;
  }
`;

export { Container, ContentContainer, Header, Text, TextContainer, CTA };
